import * as React from 'react';
import { SVGProps } from 'react';

const BookIcon: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39">
    <g clipPath="url(#a)">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.273 9.264c-3.53-3.531-9.03-3.894-12.964-1.088-.82.584-1.286 1.553-1.286 2.56V31.25c0 1.225 1.307 1.936 2.388 1.36 3.811-2.032 8.651-1.44 11.862 1.772m0-25.118v25.118m0-25.118c3.531-3.531 9.03-3.894 12.965-1.088.82.584 1.285 1.553 1.285 2.56V31.25c0 1.225-1.306 1.938-2.387 1.36-3.811-2.032-8.652-1.44-11.863 1.772"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M.89.802h38v38h-38z" />
      </clipPath>
    </defs>
  </svg>
);
export default BookIcon;
